import { GridColDef } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { GKClientDataGrid, Grid2 } from "components";
import dayjs from "dayjs";
import DashboardLayout from "layouts/DashboardLayout";
import toast from "react-hot-toast";
import axiosInstance from "utils/axiosInstance";
import { extraColumnsField } from "utils/helpers";

// Contact-form submissions from the GetVault website (getvault.in/contact-us).
const VaultInquiries = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["vault-inquiries"],
    queryFn: () => axiosInstance.get(`/api/vault-inquiries/`),
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
  });

  // accept a plain list, a { data } wrapper or a paginated { results } response
  const body = data?.data;
  const rows = Array.isArray(body) ? body : body?.data || body?.results || [];

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("Name", "firstName", 140, 1),
      valueGetter: (row) =>
        [row?.row?.firstName, row?.row?.lastName].filter(Boolean).join(" "),
    },
    {
      ...extraColumnsField("Email", "email", 180, 1),
    },
    {
      ...extraColumnsField("Reason", "reason", 160, 1),
    },
    {
      ...extraColumnsField("Platform", "platform", 120, 1),
    },
    {
      ...extraColumnsField("Message", "description", 220, 2),
    },
    {
      ...extraColumnsField("Date", "created_at", 100, 1),
      valueGetter: (row) => {
        const date = row?.row?.created_at || row?.row?.createdOn;
        return date ? dayjs(date).format("DD/MM/YYYY") : "-";
      },
    },
  ];

  return (
    <DashboardLayout title="Vault Inquiries">
      <Grid2 size={12}>
        <GKClientDataGrid
          columns={columns}
          rows={rows}
          loading={isLoading}
          showFiltersButton={false}
          getRowId={(row) =>
            row?.id ?? `${row?.email}-${row?.created_at ?? row?.createdOn}`
          }
        />
      </Grid2>
    </DashboardLayout>
  );
};

export default VaultInquiries;
